import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import FooterEdit from "../../components/FooterEdit";
import SweetAlert from "react-bootstrap-sweetalert";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faEdit,
  faEllipsisV,
  faPlusCircle,
  faPaperPlane,
  faFile,
  faArrowLeft,
  faArrowUp,
  faStarOfLife,
} from "@fortawesome/free-solid-svg-icons";
import MenuButton from "../../components/MenuButton";

class AdminEditBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem("Authorization"),
      user: [],
      brief: [],
      btype: this.props.match.params.btype,
      bstatus: "",
      isReady: 0,
      alert: null,
      modal: null,
      isRequired: 0,
      addAid: "",
      addQuestion: false,
      editQid: null,
      editQlabel: "",
      editAid: null,
      editAlabel: "",
      editAdesc: "",
      editAimage: "",
      ansImgUrl: "",
      editAtype: "",
    };
    this.confirmLogout = this.confirmLogout.bind(this);
    this.handleQuestionChange = this.handleQuestionChange.bind(this);
    this.handleRequiredChange = this.handleRequiredChange.bind(this);
    this.handleFieldAnsChange = this.handleFieldAnsChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleAnsTypeChange = this.handleAnsTypeChange.bind(this);
    this.handleQSubmit = this.handleQSubmit.bind(this);
    this.handleNewQSubmit = this.handleNewQSubmit.bind(this);
    this.handleAddAnsSubmit = this.handleAddAnsSubmit.bind(this);
    this.handleAnsUpdate = this.handleAnsUpdate.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/admincre/whois`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let msg = response.data.success;
        if (msg === true) {
          this.getAdminBrief();
          let progress = this.state.isReady + 50;
          this.setState({
            user: response.data.user,
            isReady: progress,
          });
        } else {
          this.props.history.push("/admincre/login");
        }
      });
  }

  getAdminBrief() {
    const { btype } = this.props.match.params;
    axios
      .get(`${window.localhost}/admincre/question/${btype}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.getBstatus();
          var progress = this.state.isReady + 30;
          this.setState({
            brief: response.data.brief,
            isReady: progress,
          });
          console.log(response.data.brief);
        } else {
          this.props.history.push("/admincre");
        }
      })
      .catch(() => {
        this.props.history.push("/admincre");
      });
  }

  handleMoveTop(qid) {
    axios
      .get(`${window.localhost}/admincre/question/movetop/${qid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          this.getAdminBrief();
        }
      });
  }

  getBstatus() {
    const { btype } = this.props.match.params;
    axios
      .get(`${window.localhost}/admincre/getbstatus/${btype}`, {
        header: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          let progress = this.state.isReady + 20;
          this.setState({
            bstatus: response.data.btype,
            isReady: progress,
          });
        }
      });
  }

  handleBstatusChange(bstatus) {
    const { btype } = this.props.match.params;
    const formData = new FormData();
    formData.append("status", bstatus);

    axios
      .post(`${window.localhost}/admincre/bstatus/update/${btype}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.getBstatus();
          this.updateStatusSuccess(bstatus);
        }
      });
  }

  updateStatusSuccess(bstatus) {
    const getAlert = () => (
      <SweetAlert
        success
        confirmBtnText="Oke"
        confirmBtnBsStyle="danger"
        title={
          bstatus === "published" ? "Brief Published!" : "Brief Saved as Draft!"
        }
        onConfirm={() => this.hideAlert()}
        timeout={2000}
        focusConfirmBtn
      ></SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleAddAns(qid, anstype) {
    this.setState({
      addAid: qid,
      editAtype: anstype,
    });
  }

  handleFieldAnsChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      console.log(event.target.files[0]);

      this.setState({
        [event.target.name]: event.target.files[0],
        ansImgUrl: URL.createObjectURL(event.target.files[0]),
      });
    }
  }

  handleAddAnsSubmit(e) {
    e.preventDefault();
    const { btype } = this.props.match.params;

    const formData = new FormData();
    formData.append("answer_type", this.state.editAtype);
    formData.append("answer_label", this.state.editAlabel);
    formData.append("answer_desc", this.state.editAdesc);
    if (this.state.editAimage) {
      formData.append(
        "answer_img",
        this.state.editAimage,
        this.state.editAimage.name
      );
    }

    axios
      .post(
        `${window.localhost}/admincre/answer/create/${btype}/${this.state.addAid}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            addAid: null,
            editAtype: "",
            editAlabel: "",
            editAdesc: "",
            editAimage: "",
            ansImgUrl: "",
          });
          this.getAdminBrief();
        }
      });
  }

  handleAnsUpdate(e) {
    e.preventDefault();
    const formData = new FormData();
    formData.append("answer_label", this.state.editAlabel);
    formData.append("answer_desc", this.state.editAdesc);
    if (this.state.editAimage !== "") {
      formData.append(
        "answer_img",
        this.state.editAimage,
        this.state.editAimage.name
      );
    } else {
      formData.append("answer_img", this.state.editAimage);
    }

    axios
      .post(
        `${window.localhost}/admincre/answer/update/${this.state.editAid}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            editAid: null,
            editAtype: "",
            editAlabel: "",
            editAdesc: "",
            editAimage: "",
            ansImgUrl: "",
          });
          this.getAdminBrief();
        }
      });
  }

  handleDelonlyAns(aid) {
    axios
      .delete(`${window.localhost}/admincre/answer/delonly/${aid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.getAdminBrief();
        }
      });
  }

  handleDeleteAllAns(qid) {
    const { btype } = this.props.match.params;
    axios
      .delete(`${window.localhost}/admincre/answer/delall/${btype}/${qid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.getAdminBrief();
        }
      });
  }

  handleQuestionDelete(qid) {
    axios
      .delete(`${window.localhost}/admincre/question/delonly/${qid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.handleDeleteAllAns(qid);
        }
      });
  }

  handleQEdit(qlabel, qid, qreq) {
    let reqstat = qreq == "1" ? true : false;
    this.setState({
      editQid: qid,
      editQlabel: qlabel,
      isRequired: reqstat,
      addQuestion: false,
    });
  }

  handleQuestionChange(event) {
    this.setState({
      editQlabel: event.target.value,
    });
  }

  handleRequiredChange(e) {
    this.setState({
      isRequired: e.target.checked,
    });
  }

  handleAnsTypeChange(e) {
    this.setState({
      editAtype: e.target.value,
    });
  }

  handleQSubmit(e) {
    e.preventDefault();
    const { btype } = this.props.match.params;
    const reqstat = this.state.isRequired ? 1 : 0;
    const formData = new FormData();
    formData.append("label", this.state.editQlabel);
    formData.append("required", reqstat);

    axios
      .post(
        `${window.localhost}/admincre/question/update/${btype}/${this.state.editQid}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            editQid: null,
            editQlabel: "",
          });
          this.getAdminBrief();
        }
      });
  }

  handleNewQSubmit(e) {
    e.preventDefault();
    const { btype } = this.props.match.params;
    const reqstat = this.state.isRequired ? 1 : 0;
    const formData = new FormData();
    formData.append("label", this.state.editQlabel);
    formData.append("answer_type", this.state.editAtype);
    formData.append("required", reqstat);

    axios
      .post(`${window.localhost}/admincre/question/create/${btype}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            addQuestion: false,
            editQlabel: "",
            editAtype: "",
            isRequired: false,
          });
          this.getAdminBrief();
        }
      });
  }

  confirmLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Batal"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.handleLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  handleLogout() {
    axios
      .get(`${window.localhost}/admincre/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          this.props.history.push("/admincre/login");
        }
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    if (this.state.isReady < 100) {
      return <LoadingScreen />;
    } else {
      const { user, brief } = this.state;
      const navmenu = () => {
        return (
          <div className="d-flex">
            <a
              href="https://drive.google.com/drive/folders/1_PDrslretO5dZOADTubr65CkQLf9EcTN?usp=sharing"
              className="nav-link text-danger text-decoration-none my-auto fw-bold d-none d-md-flex"
              target="_blank"
              rel="noreferrer"
            >
              Tutorial
            </a>
            <div className="dropdown">
              <button
                className="btn text-danger d-flex align-items-center dropdown-toggle"
                aria-current="page"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="me-2 d-md-flex d-none">{user.username}</span>
                <FontAwesomeIcon icon={faUserCircle} className="fs-3" />
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={this.confirmLogout}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        );
      };
      return (
        <div className="bg-light">
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Edit - Creatifa Brief App</title>
            <meta
              name="description"
              content="Brief ini untuk membantu kami dalam membuat desain logo Anda. Mohon luangkan waktu untuk mengisi dengan jawaban se-objektif mungkin. Semakin Anda menuliskan gambaran usaha Anda dengan jelas, semakin kami dapat memahami desain logo seperti apa yang Anda butuhkan"
            />
          </Helmet>
          <Header menu={navmenu()} destination={`/admincre`} />
          <div className="container wrapper-sm wrapper mb-5">
            <div className="row">
              <div className="col-md-8 col-12 d-grid gap-3 mx-auto">
                <div className="row mb-1">
                  <div className="col">
                    <div className="card bg-cream card-body rounded-4">
                      <h2 className="text-uppercase text-center">
                        Edit Form {this.state.btype}{" "}
                      </h2>
                    </div>
                  </div>
                </div>

                {brief.map((brf, i) => (
                  <div key={`quest${brf.question_num}`} className="row my-2">
                    <div className="col">
                      <div className="card rounded-4">
                        <div className="card-body d-flex justify-content-between">
                          <div className="px-2 w-100">
                            {this.state.editQid === brf.id ? (
                              <form onSubmit={this.handleQSubmit}>
                                <div className="mb-3">
                                  <label
                                    htmlFor={`quest${brf.question_num}`}
                                    className="form-label"
                                  >
                                    Question
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-cream border-0"
                                    id={`quest${brf.question_num}`}
                                    aria-describedby="questionEdit"
                                    value={this.state.editQlabel}
                                    onChange={this.handleQuestionChange}
                                    autoComplete="off"
                                  />
                                </div>

                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="flexSwitchCheckDefault"
                                    checked={this.state.isRequired}
                                    onChange={this.handleRequiredChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexSwitchCheckDefault"
                                  >
                                    Wajib diisi?
                                  </label>
                                </div>

                                <div className="btn-group float-end">
                                  <button
                                    onClick={() =>
                                      this.setState({
                                        editQid: null,
                                        editQlabel: "",
                                        isRequired: false,
                                      })
                                    }
                                    className="btn btn-secondary rounded-4 me-2"
                                  >
                                    Batal
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-warning rounded-4"
                                  >
                                    Simpan
                                  </button>
                                </div>
                              </form>
                            ) : (
                              <p className="card-title">
                                <strong>{brf.label}</strong>{" "}
                                {brf.required == "1" ? (
                                  <span className="text-danger">
                                    <FontAwesomeIcon icon={faStarOfLife} />
                                  </span>
                                ) : (
                                  ""
                                )}
                                <span className="ms-2 badge text-dark border border-1 rounded-3">
                                  {brf.answer_type}
                                </span>
                              </p>
                            )}
                          </div>
                          {this.state.editQid === brf.id ? (
                            ""
                          ) : (
                            <div className="row row-cols-2">
                              <div className="col">
                                {brf.question_num == 1 ? (
                                  ""
                                ) : (
                                  <span className="d-inline-block" tabIndex="0">
                                    <button
                                      className="btn bg-white border border-1 float-end"
                                      type="button"
                                      title="Move to Top"
                                      onClick={() => this.handleMoveTop(brf.id)}
                                    >
                                      <FontAwesomeIcon icon={faArrowUp} />
                                    </button>
                                  </span>
                                )}
                              </div>
                              <div className="col">
                                <MenuButton buttonid={`dropdown${i}`}>
                                  <li>
                                    <button
                                      onClick={() =>
                                        this.handleQEdit(
                                          brf.label,
                                          brf.id,
                                          brf.required
                                        )
                                      }
                                      className="dropdown-item"
                                    >
                                      Edit Question
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      onClick={() =>
                                        this.handleQuestionDelete(brf.id)
                                      }
                                    >
                                      Delete Question
                                    </button>
                                  </li>
                                </MenuButton>
                              </div>
                            </div>
                          )}
                        </div>

                        {brf.answer_type !== "input" &&
                        brf.answer_type !== "textarea" &&
                        brf.answer_type !== "image" ? (
                          <div className="card-body px-4 pt-0">
                            <button
                              className="btn btn-sm rounded-1 border border-1 mb-4"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${brf.id}`}
                              aria-expanded="false"
                              aria-controls={`collapse${brf.id}`}
                            >
                              Show / Hide Answer
                            </button>

                            <div
                              id={`collapse${brf.id}`}
                              className="collapse row row-cols-md-2 row-cols-1 g-4 show"
                            >
                              {brf.answer.map((ans) => (
                                <div key={`answer${ans.id}`} className="col">
                                  <div className="h-100 border border-1 p-3 rounded-4 d-flex justify-content-between">
                                    {this.state.editAid === ans.id ? (
                                      <form
                                        className="w-100"
                                        onSubmit={this.handleAnsUpdate}
                                      >
                                        <div className="mb-3">
                                          <label
                                            htmlFor={`alabel${ans.id}`}
                                            className="form-label"
                                          >
                                            Label Answer
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-cream border-0"
                                            name="editAlabel"
                                            id={`alabel${ans.id}`}
                                            aria-describedby="ansEdit"
                                            onChange={this.handleFieldAnsChange}
                                            value={this.state.editAlabel}
                                            required
                                            autoComplete="off"
                                          />
                                        </div>

                                        {brf.answer_type !== "select" &&
                                        brf.answer_type !== "radios0" ? (
                                          <div>
                                            <div className="mb-3">
                                              <label
                                                htmlFor={`adesc${brf.question_num}`}
                                                className="form-label"
                                              >
                                                Description Answer
                                              </label>
                                              <textarea
                                                type="text"
                                                className="form-control"
                                                name="editAdesc"
                                                id={`adesc${brf.question_num}`}
                                                aria-describedby="ansEdit"
                                                onChange={
                                                  this.handleFieldAnsChange
                                                }
                                                value={this.state.editAdesc}
                                                placeholder="Deskripsi panjang"
                                              />
                                            </div>

                                            <div className="mb-3">
                                              {this.state.ansImgUrl !== "" ? (
                                                <img
                                                  style={{ width: `10rem` }}
                                                  src={this.state.ansImgUrl}
                                                />
                                              ) : (
                                                ""
                                              )}
                                              <br />
                                              <label
                                                htmlFor={`aimage${brf.question_num}`}
                                                className="form-label"
                                              >
                                                Change Image?
                                              </label>
                                              <input
                                                name="editAimage"
                                                type="file"
                                                accept="image/png, image/jpeg, image/webp"
                                                id={`aimage${brf.question_num}`}
                                                aria-describedby="ansEditImage"
                                                className={`form-control form-cream border-0`}
                                                onChange={
                                                  this.handleImageChange
                                                }
                                              />
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        <div className="btn-group float-end">
                                          <button
                                            type="button"
                                            onClick={() =>
                                              this.setState({
                                                editAid: "",
                                                editAlabel: "",
                                                editAdesc: "",
                                                editAimage: "",
                                                ansImgUrl: "",
                                              })
                                            }
                                            className="btn btn-secondary rounded-4 me-2"
                                          >
                                            Batal
                                          </button>
                                          <button
                                            type="submit"
                                            className="btn btn-red text-white rounded-4"
                                          >
                                            Simpan
                                          </button>
                                        </div>
                                      </form>
                                    ) : (
                                      <div>
                                        <strong>{ans.answer_label}</strong>
                                        <p>{ans.answer_desc}</p>
                                        {ans.answer_img ? (
                                          <img
                                            className="img-fluid"
                                            src={`${window.localhost}/brief/admin/${ans.answer_img}`}
                                            alt={ans.answer_label}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )}

                                    {this.state.editAid === ans.id ? (
                                      ""
                                    ) : (
                                      <MenuButton buttonid={`dropdown${i}`}>
                                        <li>
                                          <button
                                            onClick={() =>
                                              this.setState({
                                                editAid: ans.id,
                                                editAlabel: ans.answer_label,
                                                editAdesc: ans.answer_desc,
                                                ansImgUrl:
                                                  ans.answer_img !== ""
                                                    ? `${window.localhost}/brief/admin/${ans.answer_img}`
                                                    : "",
                                              })
                                            }
                                            className="dropdown-item"
                                          >
                                            Edit Answer
                                          </button>
                                        </li>
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() =>
                                              this.handleDelonlyAns(ans.id)
                                            }
                                          >
                                            Delete Answer
                                          </button>
                                        </li>
                                      </MenuButton>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                            <hr />
                            {this.state.addAid === brf.id ? (
                              <form onSubmit={this.handleAddAnsSubmit}>
                                <div className="row mb-3">
                                  <h2 className="text-center">Add Answer</h2>
                                </div>
                                <div className="mb-3">
                                  <label
                                    htmlFor={`alabel${brf.question_num}`}
                                    className="form-label"
                                  >
                                    Label Answer
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-cream border-0"
                                    name="editAlabel"
                                    id={`alabel${brf.question_num}`}
                                    aria-describedby="ansEdit"
                                    onChange={this.handleFieldAnsChange}
                                    value={this.state.editAlabel}
                                    placeholder="Judul utama"
                                    required
                                    autoComplete="off"
                                  />
                                </div>

                                {brf.answer_type !== "select" &&
                                brf.answer_type !== "radios0" ? (
                                  <div>
                                    <div className="mb-3">
                                      <label
                                        htmlFor={`adesc${brf.question_num}`}
                                        className="form-label"
                                      >
                                        Description Answer
                                      </label>
                                      <textarea
                                        type="text"
                                        className="form-control"
                                        name="editAdesc"
                                        id={`adesc${brf.question_num}`}
                                        aria-describedby="ansEdit"
                                        onChange={this.handleFieldAnsChange}
                                        value={this.state.editAdesc}
                                        placeholder="Deskripsi panjang"
                                      />
                                    </div>

                                    <div className="mb-3">
                                      {this.state.ansImgUrl !== "" ? (
                                        <img
                                          style={{ height: `10rem` }}
                                          src={this.state.ansImgUrl}
                                        />
                                      ) : (
                                        ""
                                      )}
                                      <br />
                                      <label
                                        htmlFor={`aimage${brf.question_num}`}
                                        className="form-label"
                                      >
                                        Image Answer
                                      </label>
                                      <input
                                        name="editAimage"
                                        type="file"
                                        accept="image/png, image/jpeg, image/webp"
                                        id={`aimage${brf.question_num}`}
                                        aria-describedby="ansEditImage"
                                        className={`form-control form-cream border-0`}
                                        onChange={this.handleImageChange}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div className="btn-group float-end">
                                  <button
                                    onClick={() =>
                                      this.setState({
                                        addAid: "",
                                        editAlabel: "",
                                        editAdesc: "",
                                        editAimage: "",
                                        ansImgUrl: "",
                                      })
                                    }
                                    className="btn btn-secondary rounded-4 me-2"
                                  >
                                    Batal
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-red text-white rounded-4"
                                  >
                                    Tambah
                                  </button>
                                </div>
                              </form>
                            ) : (
                              <button
                                onClick={() =>
                                  this.handleAddAns(brf.id, brf.answer_type)
                                }
                                className="btn btn-red text-white"
                              >
                                <FontAwesomeIcon icon={faPlusCircle} /> Add
                                Answer
                              </button>
                            )}
                          </div>
                        ) : (
                          " "
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                <div className="row my-2">
                  <div className="col">
                    <div className="card rounded-4">
                      <div className="card-body d-flex justify-content-between">
                        <div className="px-2 w-100">
                          {this.state.addQuestion ? (
                            <div>
                              <div className="mb-3">
                                <h3 className="text-center">
                                  <FontAwesomeIcon icon={faPlusCircle} /> Create
                                  New Question
                                </h3>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <form onSubmit={this.handleNewQSubmit}>
                                    <div className="mb-3">
                                      <label
                                        htmlFor="newquestion"
                                        className="form-label"
                                      >
                                        Question
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-cream border-0"
                                        id="newquestion"
                                        aria-describedby="questionEdit"
                                        value={this.state.editQlabel}
                                        onChange={this.handleQuestionChange}
                                        autoComplete="off"
                                        required
                                      />
                                    </div>

                                    <div className="mb-3">
                                      <label
                                        htmlFor="anstype"
                                        className="form-label"
                                      >
                                        Answer Type
                                      </label>
                                      <select
                                        name="anstype"
                                        id="anstype"
                                        className="form-select form-cream border-0"
                                        aria-label="Default select example"
                                        onChange={this.handleAnsTypeChange}
                                        required
                                      >
                                        <option defaultValue>
                                          --- Choose Answer Type ---
                                        </option>
                                        <option value="input">
                                          Short Answer (input)
                                        </option>
                                        <option value="color">
                                          Color Answer (color)
                                        </option>
                                        <option value="textarea">
                                          Long Answer (textarea)
                                        </option>
                                        <option value="image">
                                          Upload Gambar (image)
                                        </option>
                                        <option value="select">
                                          Select Answer (select)
                                        </option>
                                        <option value="radios0">
                                          Pilihan Ganda Singkat (radios0)
                                        </option>
                                        <option value="radios2">
                                          Pilihan Ganda dengan Gambar (radios2)
                                        </option>
                                        <option value="checkbox1">
                                          Checklist lebih dari 1 bg cream
                                          (checkbox1)
                                        </option>
                                        <option value="checkbox2">
                                          Checklist lebih dari 1 bg white
                                          (checkbox2)
                                        </option>
                                      </select>
                                    </div>

                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexSwitchCheckDefault"
                                        onChange={this.handleRequiredChange}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexSwitchCheckDefault"
                                      >
                                        Wajib diisi?
                                      </label>
                                    </div>

                                    <div className="float-end">
                                      <button
                                        onClick={() =>
                                          this.setState({
                                            addQuestion: false,
                                            isRequired: 0,
                                            editAtype: null,
                                            editQlabel: null,
                                          })
                                        }
                                        type="button"
                                        className="btn btn-secondary me-2"
                                      >
                                        Batal
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-red text-white"
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center">
                              <button
                                onClick={() =>
                                  this.setState({
                                    addQuestion: true,
                                    editQid: null,
                                    editQlabel: "",
                                  })
                                }
                                className="btn btn-red text-white"
                              >
                                <FontAwesomeIcon icon={faPlusCircle} /> Create
                                New Question
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.alert}

          <FooterEdit>
            <div className="row">
              <div className="col-md-6 col-12 mx-auto">
                <div className="d-flex justify-content-between">
                  <Link
                    className="btn btn-sm btn-outline-secondary px-3"
                    to={`/admincre`}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />{" "}
                    <span className="d-md-inline d-none">Kembali</span>
                  </Link>
                  <div>
                    <button
                      type="button"
                      onClick={() => this.handleBstatusChange("draft")}
                      className={`btn btn-sm btn-outline-warning px-3 ${
                        this.state.bstatus.status === "draft" ? "disabled" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faFile} />{" "}
                      <span className="d-md-inline d-none">Draft</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => this.handleBstatusChange("published")}
                      className={`btn btn-sm btn-outline-danger px-3 ms-3 ${
                        this.state.bstatus.status === "published"
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPaperPlane} />{" "}
                      <span className="d-md-inline d-none">Publish</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </FooterEdit>
        </div>
      );
    }
  }
}
export default AdminEditBrief;
